export default __webpack_public_path__ + "static/media/ketopopcorn-wide@3x.8ea3b648.jpg";